import { render } from "./IsoZones.vue?vue&type=template&id=6f50a978&scoped=true"
import script from "./IsoZones.vue?vue&type=script&lang=js"
export * from "./IsoZones.vue?vue&type=script&lang=js"

import "./IsoZones.vue?vue&type=style&index=0&id=6f50a978&lang=less&scoped=true"

import exportComponent from "/jenkins/workspace/acs-centos8-pkg-builder/dist/rpmbuild/BUILD/cloudstack-4.19.3.0/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f50a978"]])

export default __exports__